import { LEAD_STATUS_OPTIONS } from './lead';

const REPORT_FILTERS = {
    // Filters for the Leads *Report* screen (Screens/Reports/LeadReports).
    // These keys are the query params of /reports/get-lead-report and are NOT the
    // same vocabulary as the Leads Dashboard, whose fields live in config/lead.js
    // as LEAD_DASHBOARD_FILTERS. Keep the two in step by feature, not by copying
    // keys across - they hit different endpoints.
    leads: [
        { key: 'customer_name', label: 'Customer Name', type: 'text', placeholder: 'Search by Customer Name' },
        { key: 'lead_id', label: 'Lead ID', type: 'text', placeholder: 'Search by Lead ID' },
        // Branch options are supplied at render time by LeadReports via the
        // FilterModal `dynamicOptions` prop, since the branch list is fetched.
        { key: 'branch_name', label: 'Branch', type: 'multiselect', options: [] },
        { key: 'status', label: 'Status', type: 'multiselect', options: LEAD_STATUS_OPTIONS },
        { key: 'created_from', label: 'Lead Creation Start Date', type: 'date' },
        { key: 'created_to', label: 'Lead Creation End Date', type: 'date' },
    ],

  applications: [
    { key: 'application_id', label: 'Application ID', type: 'text', placeholder: 'Search by Application ID' },
    { key: 'current_application_bucket', label: 'Parent Stage', type: 'select', options: [] },
    { key: 'application_stage_name', label: 'Application Stage', type: 'select', options: [] },
    { key: 'name', label: 'Customer Name', type: 'text', placeholder: 'Search by Customer Name' },
    { key: 'customer_id', label: 'Customer ID', type: 'text', placeholder: 'Search by Customer ID' },
    { key: 'branch_name', label: 'Branch Details', type: 'select', options: [] },
    { key: 'start_date', label: 'Created At', type: 'date_range' },
  ],

    'limit-sanction': [
        { key: 'application_id', label: 'Application ID', type: 'text' },
        { key: 'customer_name', label: 'Customer Name', type: 'text' },
        { key: 'customer_id', label: 'Customer ID', type: 'text' },
        { key: 'loan_id', label: 'Loan ID', type: 'text' },
        { key: 'branch_name', label: 'Branch', type: 'text' },
        { key: 'ro_created', label: 'RO Created', type: 'text' },
        { key: 'ro_assigned', label: 'RO Assigned', type: 'text' },
        { key: 'sanction_by', label: 'Sanctioned By', type: 'text' },
        { key: 'loan_creation_from', label: 'Loan Creation Start Date', type: 'date' },
        { key: 'loan_creation_to', label: 'Loan Creation End Date', type: 'date' },
        {
            key: 'is_signed', label: 'E-sign Status', type: 'select',
            options: [
                { label: "Yes", value: "Y" },
                { label: "No", value: "N" }
            ]
        },
    ],

    tranche: [
        { key: 'branch', label: 'Branch', type: 'text' },
        // { key: 'staff', label: 'Staff', type: 'text' },
        // { key: 'loan_creation_from', label: 'Loan Creation Start Date', type: 'date' },
        // { key: 'loan_creation_to', label: 'Loan Creation End Date', type: 'date' },
        { key: 'from_date', label: 'Loan Creation Start Date', type: 'date' },
        { key: 'to_date', label: 'Loan Creation End Date', type: 'date' },
        {
            key: 'status', label: 'Status', type: 'select',
            options: [
                { label: "Closed", value: "Closed" },
                { label: "Approved", value: "Approved" },
                { label: "Rejected", value: "Rejected" },
                { label: "Verification Pending", value: "Verification Pending" },
                { label: "Tranche Initiated", value: "Tranche Initiated" },
                { label: "Disbursal Pending", value: "Disbursal Pending" },
                { label: "Pending", value: "Pending" },
            ]
        },
        // { key: 'sector', label: 'Sector', type: 'text' },
        // { key: 'sub_sector', label: 'Sub Sector', type: 'text' },
        // { key: 'client_status', label: 'Client Status', type: 'text' },
        { key: 'supplier', label: 'Supplier', type: 'text' },
        { key: 'tranche_id', label: 'Tranche ID', type: 'text' },
        { key: 'customer_id', label: 'Customer ID', type: 'text' },
        { key: 'lms_id', label: 'LMS ID', type: 'text' },
        { key: 'customer_name', label: 'Customer Name', type: 'text' },
        // { key: 'supplier_name', label: 'Supplier Name', type: 'text' },
        { key: 'supplier_gst', label: 'Supplier GST', type: 'text' },
    ],

    supplier: [
        { key: 'branch', label: 'Branch', type: 'text' },
        {
            key: 'supplier_type', label: 'Supplier Type', type: 'select',
            options: [
                { label: "Goods Supplier", value: "Goods Supplier" },
                { label: "Service Provider", value: "Service Provider" }
            ]
        },
        {
            key: 'supplier_status', label: 'Supplier Status', type: 'select',
            options: [
                { label: "Pending", value: "Pending" },
                { label: "Verified", value: "Verified" },
                { label: "Rejected", value: "Rejected" },
                { label: "REQUEST_TO_VERIFY", value: "REQUEST_TO_VERIFY" },
            ]
        },
        { key: 'from_date', label: 'Supplier Requested Start Date', type: 'date' },
        { key: 'to_date', label: 'Supplier Requested End Date', type: 'date' },
        { key: 'supplier_name', label: 'Supplier Name', type: 'text' },
        { key: 'supplier_gst', label: 'Supplier GST', type: 'text' },
        { key: 'supplier_email', label: 'Supplier Email', type: 'text' },
        { key: 'supplier_mobile_number', label: 'Supplier Mobile Number', type: 'text' },
        { key: 'supplier_id', label: 'Supplier ID', type: 'text' },
    ],

    demand: [
        { key: 'branch', label: 'Branch', type: 'text' },
        {
            key: 'demand_type', label: 'OD Status', type: 'select',
            options: [
                { label: "Current", value: "Current" },
                { label: "Paid", value: "Paid" },
                { label: "Overdue", value: "Overdue" },
                { label: "All", value: "All" }
            ]
        },
        { key: 'demand_month', label: 'Demand Month', type: 'date', format: 'YYYY-MM' },
        { key: 'from_loan_date', label: 'Loan Creation Start Date', type: 'date' },
        { key: 'to_loan_date', label: 'Loan Creation End Date', type: 'date' },
        { key: 'customer_name', label: 'Customer Name', type: 'text' },
        { key: 'customer_id', label: 'Customer ID', type: 'text' },
        { key: 'loan_id', label: 'Loan ID', type: 'text' },
        { key: 'app_id', label: 'Application ID', type: 'text' },
        { key: 'tranche_id', label: 'Tranche ID', type: 'text' },
    ],

    'active-customer': [
        { key: 'branch_name', label: 'Branch', type: 'text' },
        { key: 'loan_created_from', label: 'Start Date', type: 'date' },
        { key: 'loan_created_to', label: 'End Date', type: 'date' },
        { key: 'customer_name', label: 'Customer Name', type: 'text' },
        { key: 'ro_name', label: 'RO Name', type: 'text' },
        { key: 'customer_id', label: 'Customer ID', type: 'text' },
        { key: 'loan_id', label: 'Loan ID', type: 'text' },
        { key: 'app_id', label: 'Application ID', type: 'text' }
    ],

    repayment: [
        { key: 'branch_name', label: 'Branch', type: 'text' },
        { key: 'customer_name', label: 'Customer Name', type: 'text' },
        { key: 'customer_id', label: 'Customer ID', type: 'text' },
        { key: 'loan_id', label: 'Loan ID', type: 'text' },
        { key: 'ro_name', label: 'RO Assigned', type: 'text' },
        { key: 'co_borrower_phone_number', label: 'Co-Borrower Phone Number', type: 'text' },
        { key: 'customer_phone_number', label: 'Customer Phone Number', type: 'text' },
        { key: 'loan_creation_from', label: 'Loan Created Start Date', type: 'date' },
        { key: 'loan_creation_to', label: 'Loan Created End Date', type: 'date' },
        {
            key: 'status', label: 'Status', type: 'select',
            options: [
                // { label: "Active", value: "Active" },
                // { label: "Closed", value: "Closed" },
                { label: "OD", value: "OD" },
                { label: "No OD", value: "No OD" },
                // { label: "All", value: "All" }
            ]
        },
    ],

  'payment-transaction': [
    // { key: 'merchant_order_id', label: 'Merchant Order ID', type: 'text' },
    { key: 'customer_id', label: 'Customer ID', type: 'text' },
    { key: 'branch_code', label: 'Branch', type: 'multiselect', options: [] },
    // { key: 'order_id', label: 'Order ID', type: 'text' },
    { key: 'transaction_status', label: 'Payment Status', type: 'select',
        options: [
            { label: "Completed", value: "COMPLETED" },
            // { label: "Failed", value: "FAILED" },
            // { label: "Pending", value: "PENDING" },
            // { label: "Expired via system", value: "EXPIRED_VIA_SYSTEM" }
        ]
    },
    // { key: 'phonepe_transaction_id', label: 'Phonepe Transaction Id', type: 'text'},
    { key: 'phonepe_reference_id', label: 'Phonepe Reference Id', type: 'text' },
    { key: 'payment_type', label: 'Entity Type', type: 'select',
        options: [
            { label: "Sanction Charge", value: "SANCTION_CHARGE" },
            { label: "Tranche Payment", value: "TRANCHE_PAYMENT" },
            { label: "Excess Amount Refund", value: "EXCESS_AMOUNT_REFUND" },
            { label: "Disbursal", value: "DISBURSAL" }
        ]
     },
    // { key: 'payment_mode', label: 'Payment Mode', type: 'select',
    //     options: [
    //         { label: "UPI Intent", value: "UPI_INTENT" },
    //         { label: "UPI Collect", value: "UPI_COLLECT" },
    //         { label: "UPI QR", value: "UPI_QR" },
    //         { label: "Net Banking", value: "NET_BANKING" },
    //         { label: "Debit Card", value: "DEBIT_CARD" },
    //         { label: "Credit Card", value: "CREDIT_CARD" },
    //     ]
    // },
    { key: 'completion_start_date', label: 'Transaction Completion Start Date', type: 'date' },
    { key: 'completion_end_date', label: 'Transaction Completion End Date', type: 'date' },
    // { key: 'creation_start_date', label: 'Transaction Creation Start Date', type: 'date' },
    // { key: 'creation_end_date', label: 'Transaction Creation End Date', type: 'date' },
  ],

    'query-management': [
        { key: 'customer_name', label: 'Customer Name', type: 'text' },
        { key: 'application_id', label: 'Application ID', type: 'text' },
        { key: 'branch_name', label: 'Branch Name', type: 'text' },
        { key: 'assigned_to_name', label: 'Assigned To', type: 'text' },
        { key: 'created_by_name', label: 'Created By', type: 'text' },
        {
            key: 'status_name',
            label: 'Status',
            type: 'select',
            options: [
                // { label: 'To Do', value: 'TO_DO' },
                // { label: 'On hold', value: 'ON_HOLD' },
                // { label: 'Cancelled', value: 'CANCELLED' },
                // { label: 'Blocked', value: 'BLOCKED' },
                // { label: 'Backlog', value: 'BACKLOG' },
                // { label: 'Completed', value: 'COMPLETED' },
                // { label: 'Approved', value: 'APPROVED' },
                // { label: 'In Progress', value: 'IN_PROGRESS' },
                // { label: 'Rejected', value: 'REJECTED' },
                // { label: 'Under Review', value: 'REVIEW' },
            ]
        },
        {
            key: 'priority',
            label: 'Priority',
            type: 'select',
            options: [
                { label: 'High', value: 'HIGH' },
                { label: 'Medium', value: 'MEDIUM' },
                { label: 'Low', value: 'LOW' },
            ]
        },
        {
            key: 'query_type',
            label: 'Query Type',
            type: 'select',
            options: [
                { label: 'Document Verification', value: 'Document Verification' },
                { label: 'Field Verification', value: 'Field Verification' },
            ]
        },
        // { 
        //     key: 'sla_breach',
        //     label: 'SLA Breach',
        //     type: 'select',
        //     options: [
        //         { label: 'Yes', value: true },
        //         { label: 'No', value: false },
        //     ]
        // },
        { key: 'created_from', label: 'Created From', type: 'date' },
        { key: 'created_to', label: 'Created To', type: 'date' },
        {
            key: 'sort_by',
            label: 'Sort By',
            type: 'select',
            options: [
                { label: 'Created Date', value: 'created_at' },
                { label: 'Due Date', value: 'due_date' },
                { label: 'Priority', value: 'priority' },
                { label: 'Status', value: 'status' },
            ]
        },
        {
            key: 'sort_order',
            label: 'Sort Order',
            type: 'select',
            options: [
                { label: 'Ascending', value: 'ASC' },
                { label: 'Descending', value: 'DESC' },
            ]
        },
        // { key: 'global_search', label: 'Global Search', type: 'text', placeholder: "Search by subtask id, title, customer name, application id, query type, assigned officer name, created by name" },
    ],
};

const REPORTS_COMPONENTS = {
    leads_view: {
        title: "Leads Report",
        permissions: [{ permission_code: "REPORTS_LEADS_VIEW" }],
    },
    leads_download: {
        title: "Leads Report",
        permissions: [{ permission_code: "DOWNLOAD_LEADS_REPORT" }],
    },
    leads_search: {
        permissions: [{ permission_code: "LEADS_REPORT_SEARCH" }],
    },
    leads_filters: {
        permissions: [{ permission_code: "LEADS_REPORT_FILTERS" }],
    },
    applications_view: {
        title: "Application Report",
        permissions: [{ permission_code: "REPORTS_APPLICATION_VIEW" }],
    },
    applications_download: {
        title: "Application Report",
        permissions: [{ permission_code: "DOWNLOAD_APPLICATION_REPORT" }],
    },
    applications_search: {
        permissions: [{ permission_code: "APPLICATION_REPORT_SEARCH" }],
    },
    applications_filters: {
        permissions: [{ permission_code: "APPLICATION_REPORT_FILTERS" }],
    },
    'limit-sanction_view': {
        title: "Limit Sanction Report",
        permissions: [{ permission_code: "REPORTS_LIMIT_SANCTION_VIEW" }],
    },
    'limit-sanction_download': {
        title: "Limit Sanction Report",
        permissions: [{ permission_code: "DOWNLOAD_LIMIT_SANCTION_REPORT" }],
    },
    'limit-sanction_search': {
        permissions: [{ permission_code: "LIMIT_SANCTION_REPORT_SEARCH" }],
    },
    'limit-sanction_filters': {
        permissions: [{ permission_code: "LIMIT_SANCTION_REPORT_FILTERS" }],
    },
    tranche_view: {
        title: "Tranche Report",
        permissions: [{ permission_code: "REPORTS_TRANCHE_VIEW" }],
    },
    tranche_download: {
        title: "Tranche Report",
        permissions: [{ permission_code: "DOWNLOAD_TRANCHE_REPORT" }],
    },
    tranche_search: {
        permissions: [{ permission_code: "TRANCHE_REPORT_SEARCH" }],
    },
    tranche_filters: {
        permissions: [{ permission_code: "TRANCHE_REPORT_FILTERS" }],
    },
    supplier_view: {
        title: "Supplier Report",
        permissions: [{ permission_code: "REPORTS_SUPPLIER_VIEW" }],
    },
    supplier_download: {
        title: "Supplier Report",
        permissions: [{ permission_code: "DOWNLOAD_SUPPLIER_REPORT" }],
    },
    supplier_search: {
        permissions: [{ permission_code: "SUPPLIER_REPORT_SEARCH" }],
    },
    supplier_filters: {
        permissions: [{ permission_code: "SUPPLIER_REPORT_FILTERS" }],
    },
    demand_view: {
        title: "Demand Report",
        permissions: [{ permission_code: "REPORTS_DEMAND_VIEW" }],
    },
    demand_download: {
        title: "Demand Report",
        permissions: [{ permission_code: "DOWNLOAD_DEMAND_REPORT" }],
    },
    demand_search: {
        permissions: [{ permission_code: "DEMAND_REPORT_SEARCH" }],
    },
    demand_filters: {
        permissions: [{ permission_code: "DEMAND_REPORT_FILTERS" }],
    },
    demand_report_generate: {
        permissions: [{ permission_code: "GENERATE_DEMAND_REPORT" }],
    },
    'active-customer_view': {
        title: "Active Customer Report",
        permissions: [{ permission_code: "REPORTS_ACTIVE_CUSTOMER_VIEW" }],
    },
    'active-customer_download': {
        title: "Active Customer Report",
        permissions: [{ permission_code: "DOWNLOAD_ACTIVE_CUSTOMER_REPORT" }],
    },
    'active-customer_search': {
        permissions: [{ permission_code: "ACTIVE_CUSTOMER_REPORT_SEARCH" }],
    },
    'active-customer_filters': {
        permissions: [{ permission_code: "ACTIVE_CUSTOMER_REPORT_FILTERS" }],
    },
    repayment_view: {
        title: "Repayment Report",
        permissions: [{ permission_code: "REPORTS_REPAYMENT_VIEW" }],
    },
    repayment_download: {
        title: "Repayment Report",
        permissions: [{ permission_code: "DOWNLOAD_REPAYMENT_REPORT" }],
    },
    repayment_search: {
        permissions: [{ permission_code: "REPAYMENT_REPORT_SEARCH" }],
    },
    repayment_filters: {
        permissions: [{ permission_code: "REPAYMENT_REPORT_FILTERS" }],
    },
    'payment-transaction_view': {
        title: "Payment Transaction Report",
        permissions: [{ permission_code: "REPORTS_PAYMENT_TRANSACTION_VIEW" }],
    },
    'payment-transaction_download': {
        title: "Payment Transaction Report",
        permissions: [{ permission_code: "DOWNLOAD_PAYMENT_TRANSACTION_REPORT" }],
    },
    'payment-transaction_search': {
        permissions: [{ permission_code: "PAYMENT_TRANSACTION_REPORT_SEARCH" }],
    },
    'payment-transaction_filters': {
        permissions: [{ permission_code: "PAYMENT_TRANSACTION_REPORT_FILTERS" }],
    },
    'query-management_view': {
        title: "Query Management Report",
        permissions: [{ permission_code: "QMS_REPORT_VIEW" }],
    },
    'query-management_download': {
        title: "Query Management Report",
        permissions: [{ permission_code: "QMS_EXPORT_REPORT" }],
    },
    'query-management_search': {
        permissions: [{ permission_code: "QMS_REPORT_SEARCH" }],
    },
    'query-management_filters': {
        permissions: [{ permission_code: "QMS_REPORT_FILTERS" }],
    },
};

export { REPORT_FILTERS, REPORTS_COMPONENTS };
